/**
 * Returns the 9-cell path for a given starting cell index.
 * Looks up paths[startIndex] from the data file.
 */
export default function pathTrace(startIndex, paths) {
  if (!Number.isInteger(startIndex) || startIndex < 0 || startIndex > 80) {
    throw new RangeError(`startIndex must be an integer in [0, 80], got ${startIndex}`);
  }
  const path = paths[startIndex];
  if (!Array.isArray(path) || path.length !== 9) {
    throw new Error(`paths[${startIndex}] must be an array of length 9`);
  }
  if (path[0] !== startIndex) {
    throw new Error(`path[${startIndex}][0] must equal startIndex (${startIndex})`);
  }
  const seen = new Set();
  for (const idx of path) {
    if (!Number.isInteger(idx) || idx < 0 || idx > 80) {
      throw new Error(`path[${startIndex}] contains invalid index ${idx}`);
    }
    if (seen.has(idx)) {
      throw new Error(`path[${startIndex}] contains duplicate index ${idx}`);
    }
    seen.add(idx);
  }
  return path;
}
